// extracted by mini-css-extract-plugin
export default {"slider-div":"PriceSlider_slider-div__BnxHg"};